import { InputAdornment, TextField as MuiTextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export const SearchInput = (props: {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  placeholder: string;
  variant: 'sidebar' | 'standard';
}) => {

  const isStandardVariant = props.variant === 'standard';

  return (
    <MuiTextField
      className={isStandardVariant ? undefined : 'sidebar-search-input'}
      label=""
      placeholder={props.placeholder}
      variant="outlined"
      color="info"
      fullWidth
      value={props.searchTerm}
      onChange={(e) => props.setSearchTerm(e.target.value)}
      size="small"
      InputProps={{
        ...(isStandardVariant
          ? {
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon color="disabled" />
              </InputAdornment>
            ),
          }
          : {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }),

        sx: {
          height: '35px',
          ...(!isStandardVariant && {
            borderRadius: '3px',
            borderColor: '#9AB4A3',
            fontSize: '12px',
            '& .MuiSvgIcon-root': {
              color: 'black',
            },
          }),
        },
      }}
      inputProps={{
        style: { height: '40px' },
      }}
    />
  );

};
